import { useCallback, useMemo } from "react";
import styles from "./styles.module.scss";
import { IContractDetailsResponseData } from "../../../../setup/api/services/contract/models";
import { ECONTRACT_STATUS } from "../../../../enums";
import DraftActions from "./DraftActions";
import CreatedActions from "./CreatedActions";
import PartiallyPaidActions from "./PartiallyPaidActions";
import WaitingForDeliveryActions from "./WaitingForDeliveryActions";
import ItemInspectionActions from "./ItemInspectionActions";
import ItemAcceptedActions from "./ItemAcceptedActions";

interface MilestoneActionsProps {
  milestone: IContractDetailsResponseData | undefined;
}

const MilestoneActions = ({ milestone }: MilestoneActionsProps) => {
  const milestoneStatus = useMemo(() => {
    return milestone?.status;
  }, [milestone?.status]);

  const renderMilestoneActions = useCallback(() => {
    if (!milestone) return null;
    switch (milestoneStatus) {
      case ECONTRACT_STATUS.DRAFT:
        return <DraftActions milestone={milestone} />;
      case ECONTRACT_STATUS.CREATED:
        return <CreatedActions milestone={milestone} />;
      case ECONTRACT_STATUS.PARTIALLY_PAID:
        return <PartiallyPaidActions milestone={milestone} />;
      case ECONTRACT_STATUS.WAITING_FOR_DELIVERY:
        return <WaitingForDeliveryActions milestone={milestone} />;
      case ECONTRACT_STATUS.ITEM_INSPECTION:
        return <ItemInspectionActions milestone={milestone} />;
      case ECONTRACT_STATUS.ITEM_ACCEPTED:
      case ECONTRACT_STATUS.READY_FOR_CASH_OUT:
      case ECONTRACT_STATUS.RESOLVED_REFUND_CUSTOMER:
      case ECONTRACT_STATUS.RESOLVED_RELEASE_PROVIDER:
      case ECONTRACT_STATUS.INSPECTION_ESCALATION:
      case ECONTRACT_STATUS.DELIVERY_ESCALATION:
      case ECONTRACT_STATUS.WAITING_FOR_SETTLEMENT_CLOSE:
      case ECONTRACT_STATUS.WAITING_FOR_SETTLEMENT_RESOLVE:
        return <ItemAcceptedActions milestone={milestone} />;
      default:
        return null;
    }
  }, [milestone, milestoneStatus]);

  if (!milestone) return null;

  return (
    <div className={styles.actionsContainer}>{renderMilestoneActions()}</div>
  );
};

export default MilestoneActions;
